import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";   // ← Importa el provider
import "./styles.css";

import App from "./App";

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <HelmetProvider>        {/* ← Envuelve tu App */}
      <App />
    </HelmetProvider>
  </StrictMode>
);
